import { jsx, jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import { addDotAtTheEndOfString } from "../../helpers/addDotAtTheEndOfString.js";
import { TOAST_COLORS } from "../constants.js";
const ToastInformation = ({ title, subtitle, type = 'informative', textLink })=>/*#__PURE__*/ jsxs("div", {
        className: "tw-flex-grow",
        children: [
            /*#__PURE__*/ jsx("h2", {
                className: clsx('tw-font-subtitle5  dark:tw-text-neutral-light-100 tw-line-clamp-3 md:tw-line-clamp-2', TOAST_COLORS[type].text.light),
                children: title
            }),
            subtitle && /*#__PURE__*/ jsxs("p", {
                className: "tw-mt-0.4 tw-text-neutral-light-700 dark:tw-text-neutral-light-100 tw-font-body5 tw-line-clamp-3 md:tw-line-clamp-2",
                children: [
                    addDotAtTheEndOfString(subtitle),
                    textLink && /*#__PURE__*/ jsx("span", {
                        className: clsx('tw-ml-0.4 dark:tw-text-inherit', TOAST_COLORS[type].text.light),
                        children: /*#__PURE__*/ jsx("a", {
                            className: "tw-font-caption tw-underline",
                            href: textLink.href,
                            target: "_blank",
                            rel: "noreferrer",
                            children: textLink.text
                        })
                    })
                ]
            })
        ]
    });
export { ToastInformation };
